import { render, staticRenderFns } from "./CopyTemplateDialog.vue?vue&type=template&id=77d5e10a"
import script from "./CopyTemplateDialog.vue?vue&type=script&lang=js"
export * from "./CopyTemplateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports